export default __webpack_public_path__ + "static/media/stock-icon.630a5292.svg";